
import { saveFastingState, clearFastingState } from '@/utils/persistenceUtils';
import { FastingProtocol } from '@/types/fasting';

/**
 * Saves fasting state to persistent storage (localStorage and cookies if allowed)
 */
export const syncFastingState = (state: {
  isActive: boolean;
  isPaused: boolean;
  timeElapsed: number;
  selectedProtocol: FastingProtocol;
  waterIntake: number;
  startTime: number | null;
  pausedTime: number | null;
  endTime: number | null;
  totalPauseDuration: number;
}) => {
  if (state.isActive || state.timeElapsed > 0) {
    saveFastingState(state);
  } else {
    clearFastingState();
  }
};
